export const langArr = {
  // index Заголовки сторінки //
    'home-page-title': {
      ua: "Фільмотека головна",
      en: "Filmoteka",
    },
    // my_library Заголовки сторінки //
    'library-page-title': {
      ua: "Фільмотека Моя бібліотека",
      en: "Filmoteka My-library",
    },
    // home-header Навігація //
    'home': {
      ua: "головна",
      en: "home",
    },
    'library': {
      ua: "моя бібліотека",
      en: "my library",
    },
    'signIn': {
      ua: "Вхід",
      en: "Sign In",
    },
    'signOut': {
      ua: "Вихід",
      en: "Sign Out",
    },
    // home-header Пошук //
    'search': {
      ua: "Пошук фільму за назвою",
      en: "Movie search",
    },
    'searchError': {
      ua: "Результат пошуку невдалий. Введіть правильну назву фільму",
      en: "Search result not successful. Enter the correct movie name",
    },
    'recomend': {
      ua: 'Рекомендовані найбільш касові фільми',
      en: 'Recommended most revenue movies',
    },
    // home-header Фільтр //
    'filters': {
      ua: "Фільтри",
      en: "Filters",
    },
    'genres': {
      ua: "Жанри",
      en: "Genres",
    },
    'action': {
      ua: "Бойовик",
      en: "Action",
    },
    'adventure': {
      ua: "Пригоди",
      en: "Adventure",
    },
    'animation': {
      ua: "Мультфільми",
      en: "Animation",
    },
    'comedy': {
      ua: "Комедія",
      en: "Comedy",
    },
    'crime': {
      ua: "Кримінал",
      en: "Crime",
    },
    'documentary': {
      ua: "Документальний",
      en: "Documentary",
    },
    'drama': {
      ua: "Драми",
      en: "Drama",
    },
    'family': {
      ua: "Сімейний",
      en: "Family",
    },
    'fantasy': {
      ua: "Фентезі",
      en: "Fantasy",
    },
    'history': {
      ua: "Історичний",
      en: "History",
    },
    'horror': {
      ua: "Жахи",
      en: "Horror",
    },
    'music': {
      ua: "Музика",
      en: "Music",
    },
    'mystery': {
      ua: "Містика",
      en: "Mystery",
    },
    'romance': {
      ua: "Романси",
      en: "Romance",
    },
    'scienceFiction': {
      ua: "Наукова фантастика",
      en: "Science Fiction",
    },
    'tvMovie': {
      ua: "Телевізійні програми",
      en: "History",
    },
    'thriller': {
      ua: "Трилер",
      en: "Thriller",
    },
    'war': {
      ua: "Військовий",
      en: "War",
    },
    'western': {
      ua: "Вестерн",
      en: "Western",
    },
    'date': {
      ua: "Дата",
      en: "Date",
    },
    'reset': {
      ua: "Оновити",
      en: "Reset",
    },
    'settings': {
      ua: "Налаштування",
      en: "Settings",
    },
    'theme': {
      ua: "Тема",
      en: "Theme",
    },
    // home-header new film // 
    'new-movies': {
      ua: 'нові найкращі фільми онлайн',
      en: 'new best movies online',
    },
    // library-header Кнопки додавання фільмів //
      'watched': {
        ua: "Переглянуті",
        en: "Watched",
      },
      'queue': {
        ua: "В черзі",
        en: "Queue",
      },
    // Footer //
    'application': {
      ua: "Наш додаток",
      en: "Our Application",
    },
    'support': {
      ua: "Підтримка",
      en: "Support",
    },
    'networks': {
      ua: "Приєднуйтесь до наших соцмереж",
      en: "Join our networks",
    },
    'reserved': {
      ua: "Усі права захищено",
      en: "All Rights Reserved",
    },
    'developed': {
      ua: "розроблено з",
      en: "Developed with",
    },
    'by': {
      ua: "",
      en: "by",
    },
    'students': {
      ua: "студентами GoIT",
      en: "GoIT Students",
    },
  // modal-registration // 
  'titel-register': {
    ua: "Будь ласка, введіть свою електронну пошту та пароль",
    en: "Please enter your e-mail and password",
  },
  'mail': {
    ua: "Пошта",
    en: "E-mail",
  },
  'pass': {
    ua: "Пароль",
    en: "Password",
  },  
  'sign-up': {
    ua: "Зареєструватися",
    en: "Sign up",
  },  
  'sign-in': {
    ua: "Увійти",
    en: "Sign in",
  },
  // Library section films // 
  'movies-list-library-1': {
    ua: 'Тут буде ваш список фільмів. Ви можете наповнити його на',
    en: 'Here will be your list of movies. You can fill them',
  }, 
  'movies-list-library-2': {
    ua: 'ГОЛОВНІЙ',
    en: 'HOME',
  }, 
  'movies-list-library-3': {
    ua: 'сторінці',
    en: 'page',
  },
  // Modal Film //
  'vote': {
    ua: 'Рейтинг / Голоси',
    en: 'Vote / Votes',
  },
  'popularity': {
    ua: 'Популярність',
    en: 'Popularity',
  },
  'genre': {
    ua: 'Жанр',
    en: 'Genre',
  },
  'about': {
    ua: 'Про фільм',
    en: 'About',
  },
  'add-watched': {
    ua: 'переглянуто',
    en: 'add to watched',
  },
  'remove-watched': {
    ua: 'видалити з переглянутих',
    en: 'remove from watched',
  },
  'add-queue': {
    ua: 'додати в чергу',
    en: 'add to queue',
  },
  'remove-queue': {
    ua: 'видалити з черги',
    en: 'remove from queue',
  },
  'watch-trailers': {
    ua: 'Дивитись трейлер',
    en: 'Watch trailers',
  },
  'org-title': {
    ua: 'Оригінальна назва',
    en: 'Original title',
  },
  // modal-team.html //
'mushko': {
  ua: 'Альона Мишко',
  en: 'Alena Mushko',
},
'team-lead': {
  ua: 'Тімлід',
  en: 'Team Lead',
},
'vodvud': {
  ua: 'Надія Водвуд',
  en: 'Vodvud Nadiya',
},
'scrum-master': {
  ua: 'Скрам майстер',
  en: 'Scrum master',
},
'bezsiniy': {
  ua: 'Павло Безсінний',
  en: 'Pavlo Bezsinniy',
},
'developer1': {
  ua: 'Розробник',
  en: 'Developer',
},
'kovalenko': {
  ua: 'Світлана Коваленко',
  en: 'Svitlana Kovalenko',
},
'developer2': {
  ua: 'Розробник',
  en: 'Developer',
},
'nikonov': {
  ua: 'Олександр Ніконов',
  en: 'Alexandr Nikonov',
},
'developer3': {
  ua: 'Розробник',
  en: 'Developer',
},
'volodko': {
  ua: 'Денис Володько',
  en: 'Denys Volodko',
},
'developer4': {
  ua: 'Розробник',
  en: 'Developer',
},
'katishev': {
  ua: 'Олександр Катишев',
  en: 'Olexandr Katyshev',
},
'developer5': {
  ua: 'Розробник',
  en: 'Developer',
},
'filipenko': {
  ua: 'Анастасія Філіпенко',
  en: 'Anastasiya Filipenko',
},
'developer6': {
  ua: 'Розробник',
  en: 'Developer',
},
'shkilniuk': {
  ua: 'Дмитро Шкільнюк',
  en: 'Dmytro Shkilniuk',
},
'developer7': {
  ua: 'Розробник',
  en: 'Developer',
},
'protas': {
  ua: 'Тетяна Протас',
  en: 'Tetyana Protas',
},
'developer8': {
  ua: 'Розробник',
  en: 'Developer',
},
'stolbin': {
  ua: 'Микита Столбін',
  en: 'Mykyta Stolbin',
},
'developer9': {
  ua: 'Розробник',
  en: 'Developer',
},
};